<div class="general-container">
    <div class="inp-container">
        <ion-skeleton-text animated style="width: 70%; height: 20px;"></ion-skeleton-text>
    </div>
</div>
